// extracted by mini-css-extract-plugin
export var contentBody = "_4v-9";
export var headerImage = "_4v-2";
export var imageButton = "_4v-7";
export var imageButtonIcon = "_4v-8";
export var imageHeader = "_4v-4";
export var imageHeaderText = "_4v-5";
export var imageOverlay = "_4v-3";
export var imageTitle = "_4v-6";
export var imageWrapper = "_4v-1";
export var taskList = "_4v-a";
export var widget = "_4v-0";